module.exports = __webpack_public_path__ + "static/media/19ESCAP39.eb08c332.jpg";